import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'
import { InWinImage } from 'routes/shared/components'

import * as styles from './styles'

const AthleteCardComponent = ({ athlete }) => (
  <figure css={styles.card}>
    <InWinImage
      source={athlete.logo}
      fallbackSource="/img/avatar-placeholder.png"
      alt={athlete.fullName}
    />
    <figcaption css={styles.caption}>
      <Text size={16} bold>
        {athlete.fullName}
      </Text>
    </figcaption>
  </figure>
)

AthleteCardComponent.propTypes = {
  athlete: PropTypes.shape(),
}

export default AthleteCardComponent
